import { pathOr } from 'ramda';
import * as React from 'react';

import { useContext } from '../../../utils/useContext';
import { Contact } from '../../../components/advancedFilters/Contact';

export const ContactPhoneContainer: React.FC = () => {
  const { jsonQuery, onChange } = useContext();
  const contactPhone = pathOr<string | null>(null, ['contact', 'value'], jsonQuery);

  const handleChangeContactPhone = React.useCallback(
    (phone: string | null) => {
      onChange({ action: 'setContact', arguments: [phone] });
    },
    [onChange],
  );

  return <Contact contactPhone={contactPhone} onContactPhoneChange={handleChangeContactPhone} />;
};
